import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { LccUser } from './types';

/**
 * Autenticacion de DESARROLLO: simula el usuario autenticado sin requerir claves de Clerk.
 * En produccion, este provider se reemplaza por ClerkAuthProvider (ver ClerkAuthProvider.tsx),
 * que expone exactamente la misma interfaz (useCurrentUser), por lo que ningun modulo
 * necesita cambiar codigo al pasar de "local" a "remote" (principio de Inversion de Dependencias).
 */
const DEV_USERS: LccUser[] = [
  { id: 'dev-carolina', fullName: 'CAROLINA SALGADO', role: 'supervisor' },
  { id: 'dev-lina', fullName: 'LINA RESTREPO', role: 'operator' },
  { id: 'dev-ferney', fullName: 'FERNEY ALVAREZ', role: 'operator' },
  { id: 'dev-marisol', fullName: 'MARISOL RIVAS', role: 'operator' },
  { id: 'dev-jhoan', fullName: 'JHOAN ALEXANDER', role: 'admin' },
  { id: 'dev-michael', fullName: 'MICHAEL AVELLANEDA', role: 'operator' },
  { id: 'dev-leidy', fullName: 'LEIDY SARRAZOLA', role: 'operator' },
  { id: 'dev-aduanador', fullName: 'ADUANADOR', role: 'operator' },
  { id: 'dev-mateo', fullName: 'MATEO MURIEL', role: 'operator' },
];

interface AuthContextValue {
  user: LccUser;
  users: LccUser[];
  switchUser: (id: string) => void;
  isDevMode: true;
}

const AuthContext = createContext<AuthContextValue | null>(null);
const STORAGE_KEY = 'lcc.dev.currentUserId';

export function DevAuthProvider({ children }: { children: ReactNode }) {
  const [userId, setUserId] = useState(() => localStorage.getItem(STORAGE_KEY) ?? DEV_USERS[0].id);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, userId);
  }, [userId]);

  const user = DEV_USERS.find((u) => u.id === userId) ?? DEV_USERS[0];

  return (
    <AuthContext.Provider value={{ user, users: DEV_USERS, switchUser: setUserId, isDevMode: true }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useDevAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useDevAuth debe usarse dentro de <DevAuthProvider>');
  return ctx;
}
